import React from 'react';

export interface AuditsConfig {
    autoChecksEnabled?: boolean;
    auditAnalysisEnabled?: boolean;
    auditTagsEnabled?: boolean;
    canBypassManagerEnabled?: boolean;
}

export const DefaultAuditConfig = {
    auditAnalysisEnabled: true,
    autoChecksEnabled: true,
    auditTagsEnabled: false,
    canBypassManagerEnabled: false,
};

export const AuditsContext = React.createContext<AuditsConfig>(DefaultAuditConfig);
export const useAuditsConfig = () => React.useContext(AuditsContext);
